import { Head, Notes, Image } from 'mdx-deck';
import { CodeSurfer, CodeSurferColumns, Step } from "code-surfer";
import { vsDark, github, dracula } from "@code-surfer/themes";
import customTheme from "../../../../../../theme";
import "../../../../../../styles.css";
import wcagDocsGif from "../../../../../../assets/wcagDocs.gif";
import designPatternsImage from "../../../../../../assets/designPatterns.png";
import alertDesignPattern from "../../../../../../assets/alertDesignPattern.png";
import alertExample1 from "../../../../../../assets/alertExample1.png";
import alertExample2 from "../../../../../../assets/alertExample2.png";
import alertExample3 from "../../../../../../assets/alertExample3.png";
import designPatternsIntro from "../../../../../../assets/designPatternsIntro.png";
import designPatternsIntro2 from "../../../../../../assets/designPatternsIntro2.png";
import designPatternsIntro3 from "../../../../../../assets/designPatternsIntro3.png";
import designPatternsMenuExample from "../../../../../../assets/designPatternsMenuExample.png";
import keyboardNav from "../../../../../../assets/keyboardNav.png";
import buttonAriaDocs from "../../../../../../assets/buttonAriaDocs.png";
import buttonAriaRole from "../../../../../../assets/buttonAriaRole.png";
import buttonAriaLabel from "../../../../../../assets/buttonAriaLabel.png";
import buttonAriaDisabled from "../../../../../../assets/buttonAriaDisabled.png";
import buttonActivate from "../../../../../../assets/buttonActivate.png";
import keyboardFocus1 from "../../../../../../assets/keyboardFocus1.gif";
import keyboardFocus2 from "../../../../../../assets/keyboardFocus2.gif";
import Layout from "../../../../../../components/Layout.js";
import FullImage from "../../../../../../components/FullImage.js";
import List from "../../../../../../components/List.js";
import Button from "../../../../../../components/Button.js";
import React from 'react';
export default {
  Head: Head,
  Notes: Notes,
  Image: Image,
  CodeSurfer: CodeSurfer,
  CodeSurferColumns: CodeSurferColumns,
  Step: Step,
  vsDark: vsDark,
  github: github,
  dracula: dracula,
  customTheme: customTheme,
  wcagDocsGif: wcagDocsGif,
  designPatternsImage: designPatternsImage,
  alertDesignPattern: alertDesignPattern,
  alertExample1: alertExample1,
  alertExample2: alertExample2,
  alertExample3: alertExample3,
  designPatternsIntro: designPatternsIntro,
  designPatternsIntro2: designPatternsIntro2,
  designPatternsIntro3: designPatternsIntro3,
  designPatternsMenuExample: designPatternsMenuExample,
  keyboardNav: keyboardNav,
  buttonAriaDocs: buttonAriaDocs,
  buttonAriaRole: buttonAriaRole,
  buttonAriaLabel: buttonAriaLabel,
  buttonAriaDisabled: buttonAriaDisabled,
  buttonActivate: buttonActivate,
  keyboardFocus1: keyboardFocus1,
  keyboardFocus2: keyboardFocus2,
  Layout: Layout,
  FullImage: FullImage,
  List: List,
  Button: Button,
  React: React
};